export function getAuthorFromPost(post) {
  if (!post._embedded) return null
  const { author } = post._embedded
  return author && author[0]
}
